import { LegalNotice, NoticeOfEntryNotice } from '../../constants';

export const isLegalNotice = (values) => {
  return values.notice_type === LegalNotice;
};

export const isNoticeOfEntryNotice = (values) => {
  return values.notice_type === NoticeOfEntryNotice;
};
